import FileSaver from 'file-saver'
import ContentDisposition from 'content-disposition'
import ReportsService from '@/services/ReportsService';
import { i18n } from "@/i18n";
import { useToast } from 'bootstrap-vue-next';

export default {
  setup() {
    const { show } = useToast();
    return { showToast: show };
  },

  methods: {
    downloadFile: function(response) {
      let disposition = ContentDisposition.parse(response.headers['content-disposition']);

      if (disposition && disposition.parameters && disposition.parameters.filename)
        FileSaver.saveAs(response.data, disposition.parameters.filename);
      else
        FileSaver.saveAs(response.data);
    },

    downloadReportForSurveyInstance(surveyInstanceId) {
      ReportsService.getCheckReport(
        surveyInstanceId,
        { localizationId: i18n.global.locale })
        .then(response => {
          this.downloadFile(response);
        })
        .catch(_ => {

          this.showToast({
            props: {
              title: this.$t("Webportal.CX.Margin.CheckReportErrorMessage", {
                entity: this.$t("Webportal.CX.Margin.CheckReportErrorTitle"),
              }),
              variant: "danger",
              autoHide: true,
              delay: 5000,
              noCloseButton: true
            }
          });
        }
      )
    },

    getFileIcon(fileName) {
      return fileName.match(/.(pdf)$/i)
        ? "file-pdf"
        : fileName.match(/.(doc|dot|docx|docm|dotx|docb|rtf)$/i)
        ? "file-word"
        : fileName.match(/.(jpg|jpeg|png|gif)$/i)
        ? "file-image"
        : fileName.match(/.(xls|xlt|xlm|xlsx|xlsm|xltx|xltm)$/i)
        ? "file-excel"
        : fileName.match(
            /.(ppt|pot|pps|pptx|pptm|potx|potm|ppam|ppsx|ppsm|sldx|sldm)$/i
          )
        ? "file-powerpoint"
        : fileName.match(
            /.(webm|mpg|mp2|mpeg|mpe|mpv|mp4|m4p|m4v|avi|mkv|wmv|mov|qt|flv|swf)$/i
          )
        ? "file-video"
        : fileName.match(/.(m4a|flac|mp3|ogg|wav|wma|aac|mid)$/i)
        ? "file-audio"
        : "file";
    },
  }
}